import auth0 from 'auth0-js';
import env from '@utils/env';

export const authService = new auth0.WebAuth({
  domain: env.AUTH_DOMAIN,
  clientID: env.CLIENT_ID,
  redirectUri: `${window.location.origin}/authenticate`,
  responseType: 'token id_token',
  scope: 'openid profile email',
  audience: env.AUDIENCE,
  leeway: 60,
});
